import React from 'react';
import cn from 'classnames';
import InputButton from './InputButton';
import { observer } from 'store';
import { getInputControls } from '../utils';
import * as styles from './InputGroup.module.scss';

const InputGroup = ({ className, label, type, layout = 'column', options }) => {
  const { getValue, handleChange } = getInputControls(type, label);

  return (
    <div className={cn(styles.inputGroup, styles[layout], className)}>
      {options?.map(item => (
        <InputButton
          key={item.name}
          type={type}
          className={styles.button}
          theme={layout}
          onChange={() => handleChange(item.name)}
          checked={getValue(item.name)}
          {...item}
        />
      ))}
    </div>
  );
};

export default observer(InputGroup);
